import _ from 'lodash'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { PieChart, Pie, Cell, LabelList } from 'recharts'
import { bindActionCreators } from 'redux'
import styled, { css } from 'styled-components'

import values from 'core/data-model/constants/values'
import { svgStringToBase64 } from 'core/service/lib/tobase64'
import { saveImage } from 'quick-quote/ui/actions'

import { getPatternByIndex } from './chart-patterns'

export const fundGroupColor = (index) => values.PIE_CHART_FUND_COLORS[index % values.PIE_CHART_FUND_COLORS.length]

const chartDisplayConfig = {
  S: {
    width: 800,
    height: 800,
    fontSize: 45,
  },
  M: {
    width: 800,
    height: 800,
    fontSize: 40,
  },
  L: {
    width: 800,
    height: 800,
    fontSize: 35,
  },
}

export const PieChartSize = {
  S: 'S',
  M: 'M',
  L: 'L',
}

const Wrapper = styled.div`
  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
`

const getChartDisplayConfig = (size) => {
  return _.get(chartDisplayConfig, size, chartDisplayConfig.L)
}

// To generate pattern as base64 png image for pie-chart
export const generatePatterns = async () => {
  const patterns = []
  for (let index = 0; index < values.PIE_CHART_FUND_COLORS.length; index++) {
    const { string, url } = getPatternByIndex(index)
    const imageSVG = `<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><defs>${string}</defs><rect width="30" height="30" fill="${url}"/></svg>`
    const chart = await svgStringToBase64(imageSVG)
    patterns.push(chart)
  }
  return patterns
}

export const Component = ({ data, size, imageId, hide, saveImage }) => {
  const { width, height, fontSize } = getChartDisplayConfig(size)

  const pieDataTransformed = data.map((item, index) => {
    const { name, value } = item
    const { color, string, url } = getPatternByIndex(index)
    return {
      name,
      value,
      label: `${value}%`,
      color: color,
      pattern: string,
      patternURL: url,
    }
  })

  const addPatternScale = (patternDefString) =>
    patternDefString.replace('<pattern ', '<pattern patternTransform="scale(4 4)"')

  useEffect(async () => {
    if (imageId) {
      const chartContainer = document.getElementById(`fund-allocation-chart-container--${imageId}`)
      if (!chartContainer) return ''
      let svgTag = chartContainer.innerHTML.match(/<svg[\s\S]*?svg>/)
      if (!svgTag) return ''
      const resultSVGString = svgTag[0].replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ')
      const chart = await svgStringToBase64(resultSVGString)
      saveImage(imageId, chart)
    }
  }, [])

  return (
    <Wrapper id={`fund-allocation-chart-container--${imageId}`} hide={hide}>
      <PieChart width={width} height={height} xmlns="http://www.w3.org/2000/svg">
        {pieDataTransformed.map((entry, index) => (
          <defs key={`def-${index}`} dangerouslySetInnerHTML={{ __html: `${addPatternScale(entry.pattern)}` }} />
        ))}
        <Pie
          data={pieDataTransformed}
          dataKey="value"
          nameKey="name"
          startAngle={90}
          endAngle={-270}
          isAnimationActive={false}
          fill="#8884d8"
        >
          {pieDataTransformed.map((entry, index) => (
            <Cell key={index} fill={entry.patternURL} />
          ))}
          <LabelList dataKey="label" position="top" fill={'black'} stroke={'none'} fontSize={fontSize} />
        </Pie>
      </PieChart>
    </Wrapper>
  )
}
Component.displayName = 'FundAllocationPieChart'
export const FundAllocationPieChart = connect(null, (dispatch) => ({
  saveImage: bindActionCreators(saveImage, dispatch),
}))(Component)
